import React, { useEffect, useMemo, useState } from "react";
import ReactHtmlParser from "react-html-parser";
import { useDispatch, useSelector } from "react-redux";

import MicroModal from "micromodal";
import Audio from "../../../../Audio/Audio";
import Table from "../../../../table/Table";

import Typography from "../../../../Typography";
import { Tooltippy } from "../../../../../actions/Tippy";

import Loading from "../../../../Loading";

import { ReactComponent as CloseIcon } from "../../../../../build/images/close-circle.svg";
import { ReactComponent as ArrowBackIcon } from "../../../../../build/images/arrow_back.svg";
import { ReactComponent as ChevronLeftIcon } from "../../../../../build/images/nps-dashboard-icons/chevron-left.svg";
import { ReactComponent as SearchIcon } from "../../../../../build/images/nps-dashboard-icons/search.svg";
import { ReactComponent as ChevronRightIcon } from "../../../../../build/images/nps-dashboard-icons/chevron-right.svg";
import { ReactComponent as HappyRating } from "../../../../../build/images/icons-rating/happy.svg";
import { ReactComponent as IndifRating } from "../../../../../build/images/icons-rating/indifferent.svg";
import { ReactComponent as IconDownloadAudio } from "../../../../../build/images/direct-inbox.svg";
import { ReactComponent as SadRating } from "../../../../../build/images/icons-rating/sad.svg";
import { ReactComponent as NullRating } from "../../../../../build/images/icons-rating/star-slash.svg";
import { ReactComponent as IconSeeInteraction } from "../../../../../build/images/messages-2.svg";
import { ReactComponent as UserProfileIcon } from "../../../../../build/images/nps-dashboard-icons/usericon.svg";
import { ReactComponent as ArrowsIcon } from "../../../../../build/images/nps-dashboard-icons/arrows.svg";
import { ReactComponent as Play } from "../../../../../build/images/chatIcons/PlayIcon.svg";
import { ReactComponent as PlayDisabled } from "../../../../../build/images/chatIcons/PlayDisabled.svg";
import { ReactComponent as IconMessageNull } from "../../../../../build/images/messages-3.svg";
import TWITTER from "../../../../../build/images/twitter-new.svg";
import MIDIAFACE from "../../../../../build/images/facebook_new.svg";
import { ReactComponent as SMSICON } from "../../../../../build/images/sms-new.svg";
import { ReactComponent as MIDIAZAP } from "../../../../../build/images/icons-channels/whatsapp2-large.svg";
import { ReactComponent as MIDIAEMAIL } from "../../../../../build/images/email-new.svg";
import { ReactComponent as MIDIAWEB } from "../../../../../build/images/webchat-new.svg";
import { ReactComponent as CALLCHAT } from "../../../../../build/images/callchat-new.svg";
import { ReactComponent as MIDIATELEGRAM } from "../../../../../build/images/telegram-new.svg";
import { ReactComponent as GOOGLEGBM } from "../../../../../build/images/googlegbm-new.svg";
import { ReactComponent as LINKEDIN } from "../../../../../build/images/linkedin-new.svg";
import { ReactComponent as INSTAGRAM } from "../../../../../build/images/instagram_new.svg";
import { ReactComponent as TEAMS } from "../../../../../build/images/channels/teamsMedium.svg";

import TWITTER2 from "../../../../../build/images/twitter-new.svg";
import MIDIAFACE2 from "../../../../../build/images/facebook_new.svg";
import MIDIAZAP2 from "../../../../../build/images/icons-channels/whatsapp2-large.svg";
import MIDIAEMAIL2 from "../../../../../build/images/email-new.svg";
import MIDIAWEB2 from "../../../../../build/images/webchat-new.svg";
import CALLCHAT2 from "../../../../../build/images/callchat-new.svg";
import TELEGRAM2 from "../../../../../build/images/channels/telegram.svg";
import MIDIATELEGRAM2 from "../../../../../build/images/telegram-new.svg";
import GOOGLEGBM2 from "../../../../../build/images/googlegbm-new.svg";
import LINKEDIN2 from "../../../../../build/images/linkedin-new.svg";
import INSTAGRAM2 from "../../../../../build/images/instagram_new.svg";
import TEAMS2 from "../../../../../build/images/channels/teamsMedium.svg";

import {
  DownloadFile,
  CarregamentoInteractions,
  GetHistory,
  InteracoesDealGet,
  GetDetailsContacts,
  AddNumberContact,
  GetPhoneMidia,
} from "../../../../../actions";

import "./user-interaction.css";
import axios from "axios";
import InteractionComment from "../../../../InteractionComment/InteractionComment";
import { handleFiles } from "../../../../../actions/files";
import blockClick from "../../../../../actions/blockClick";

const { connection_platform } = require("../../../../../services/api");

let dia = "";
let auxdia = "";
var gethostname = window.location.hostname;
var pathname = "";

var iplocal = connection_platform.ip_intern;
var port = connection_platform.port_backend_intern;

port = localStorage.getItem("port");

var clientTest = "";

if (gethostname === "localhost") pathname = iplocal;
else pathname = gethostname;

var ipcurrent = pathname;

if (pathname !== connection_platform.ip_intern) {
  ipcurrent = connection_platform.ip_apache_view_extern;
  //if(parseInt(connection_platform.port_apache_view_extern) !== 80){
  ipcurrent = ipcurrent + ":" + connection_platform.port_apache_view_extern;
  //}
} else {
  ipcurrent = connection_platform.ip_apache_view_intern;
  //if(parseInt(connection_platform.port_apache_view_intern) !== 80){
  ipcurrent = ipcurrent + ":" + connection_platform.port_apache_view_intern;
  //}
}

const mimetypesPrincipal = [
  "image",
  "voice",
  "document",
  "audio",
  "txt",
  "video",
];

export default function UserInteraction({
  userHistoryDrawer,
  onCloseDrawer,
  treatmentData,
}) {
  const [loading, setLoading] = useState(false);
  const [loadingHis, setLoadingHis] = useState(false);
  const [isDialogVisible, setIsDialogVisible] = useState(true);
  const [userHistory, setUserHistory] = useState([]);
  const Mimetypes = useSelector((state) => state.mimetypes);
  const [historys, setHistorys] = useState([]);
  const dialogsInteractions = useSelector(
    (state) => state.interactions.interactions
  );
  const InfoUsers = useSelector((state) => state.informationusers);
  const [changeInteractions, setChangeInteractions] = useState([]);
  const ContactId = useSelector((state) => state.atendimento);
  const [dataTitle, setDataTitle] = useState({
    operator: null,
    client: null,
    note: null,
    date: null,
    midiaid: 0,
    interaction: [],
  });
  const dispatch = useDispatch();
  const [termText, setTermText] = useState("");
  const InteractionsNumber = useSelector((state) => state.interactions);
  const History = useSelector((state) => state.history);

  port = localStorage.getItem("port");

  useEffect(() => {
    if (InteractionsNumber.length !== 0) {
      if (InteractionsNumber.interactions.length !== 0) {
        setChangeInteractions(InteractionsNumber.interactions);
      } else {
        setChangeInteractions([]);
        setLoading(false);
      }
    }
  }, [InteractionsNumber]);

  const returnScreenDrawer = () => {
    if (!isDialogVisible) {
      setIsDialogVisible(true);
    } else {
      onCloseDrawer();
    }
  };

  useEffect(() => {
    if (History.length != 0) {
      setLoadingHis(true);
      refactorHistory(History);
    } else {
      setHistorys([]);
      setLoadingHis(false);
    }
  }, [History]);

  function renderSatisfaction(nota) {
    if (nota >= 9) {
      return (
        <Tooltippy content={nota} placement="top-start">
          <div className="username-rating__tag happy">
            <HappyRating />
            <div className="client_happy">Cliente satisfeito</div>
          </div>
        </Tooltippy>
      );
    } else if (nota === 7 || nota === 8) {
      return (
        <Tooltippy content={nota} placement="top-start">
          <div className="username-rating__tag indifferent">
            <IndifRating />
            <div className="client_indifferent">Cliente indiferente</div>
          </div>
        </Tooltippy>
      );
    } else if (nota >= 0 && nota <= 6) {
      return (
        <Tooltippy content={nota} placement="top-start">
          <div className="username-rating__tag sad">
            <SadRating />
            <div className="client_sad">Cliente insatisfeito</div>
          </div>
        </Tooltippy>
      );
    } else {
      return (
        <div className="username-rating__tag">
          <NullRating />
          <div className="client_nulo">Nenhuma avaliação</div>
        </div>
      );
    }
  }

  // ######## nova função refactorHistory #############

  async function refactorHistory(historys) {
    const processed = [];
    for (const history of historys) {
      const hasMessagem = !!history && !!history.messagem;
      if (hasMessagem) {
        history.messagem = history.messagem.replace(
          /\\U([0-9a-fA-F]{8})/g,
          (match, hex) => {
            return String.fromCodePoint(parseInt(hex, 16));
          }
        );
      }

      if (
        mimetypesPrincipal.includes(history.typename) &&
        !history.messagem.includes("https")
      ) {
        const response = await handleFiles(history.messagem);

        if (response) {
          try {
            const fileObject = {
              name: response.name,
              size: response.size,
              type: response.typeMime,
              path_arquivos: history.messagem,
              extension: response.type,
              id: history.id,
            };
            history.file = fileObject;
          } catch (error) {
            return true;
          }
        }

        //Busca as informações do mimetype caso venha o link completo do arquivo
      } else if (
        mimetypesPrincipal.includes(history.typename) &&
        history.messagem.includes("https")
      ) {
        const mimetype = Mimetypes.find(
          (element) => history.mimetypeid === element.id
        );
        history.mimetype = mimetype;

        //Caso a mensagem seja um json, ele faz o parse para ler o json
      } else if (history.typename === "application") {
        // history.messagem = JSON.parse(history.messagem).msg || JSON.parse(history.messagem).MSG;
        try {
          if (
            JSON.parse(history.messagem).msg ||
            JSON.parse(history.messagem).MSG
          ) {
            history.messagem =
              JSON.parse(history.messagem).msg ||
              JSON.parse(history.messagem).MSG;
          }

          history.messagem = createJSON(history.messagem);
        } catch (err) {
          console.log("Error: ", err.message);
        }

        //Caso seja auditória de voz, formata o link que vem do back (vem sem formatação) para poder chamar a função que busca as informações do arquivo.
      } else if (history.typename === "Interactive") {
        if (history.mimetypeid >= 33 && history.mimetypeid <= 36) {
          try {
            let sanitizedMessage = history.messagem.replace(
              /[\u0000-\u001F\u007F-\u009F]/g,
              ""
            );
            let json = JSON.parse(sanitizedMessage);

            history.buttons = json.buttons;
            history.botid = json.botid;

            if (!!json && !!json.msg && typeof json.msg === "string") {
              history.messagem = json.msg;
            }

            if (json.link) {
              const response = await handleFiles(json.link);
              try {
                const fileObject = {
                  name: response.name,
                  size: response.size,
                  type: response.typeMime,
                  path_arquivos: json.link,
                  extension: response.type,
                  id: history.id,
                };
                history.file = fileObject;
              } catch (error) {
                console.error("Erro ao processar arquivo:", error);
                return true;
              }
            }
          } catch (error) {
            console.error("JSON inválido em history.messagem:", error);
          }
        } else if (history.mimetypeid === 37) {
          let message = history.messagem.replaceAll("\r\n", "\\n");
          let json = JSON.parse(message);
          history.buttons = json.items;
          history.botid = json.botid;
        } else if (history.mimetypeid === 50) {
          let message = history.messagem.replaceAll("\r\n", "\\n");
          // let json = JSON.parse(message);
          let json;
          try {
            // tenta parsear como JSON string
            json = JSON.parse(message);
          } catch (e) {
            // se der erro, já é objeto
            json = message;
          }
          let msgFinal = "";

          if (typeof json === "object" && json !== null && json.botid) {
            let msg = json.msg;
            if (json.header) {
              msg = `*${json.header}*\n${msg}\n`;
            }

            msgFinal = msg;

            history.buttons = [
              {
                text: json.footer,
                flowCta: json.flow_cta,
              },
            ];
            history.botid = json.botid;
          } else if (typeof json === "object" && json !== null) {
            let newMsg = Object.entries(json)
              .filter(([key]) => key !== "flow_token")
              .map(([key, value]) => `*${key}*\n_${value}_\n`)
              .join("");
            msgFinal = newMsg;
          }

          history.messagem = msgFinal;
        }
      } else if (history.typename === "location") {
        let json = JSON.parse(history.messagem);
        history.location = {
          latitude: json.latitude ? json.latitude : json.LATITUDE,
          longitude: json.longitude ? json.longitude : json.LONGITUDE,
          nomeEndereco: json.name ? json.name : json.NAME,
          endereco: json.address ? json.address : json.ADDRESS,
        };
      } else if (history.typename === "hsm") {
        const verifyJson = isJson(history.messagem);
        // let json = "";

        if (!verifyJson) {
          history.messagem = JSON.stringify(
            history.messagem.replace(/'/g, '"')
          );
          // .replace(/\'/g, '"');
        }

        let json = JSON.parse(history.messagem);

        if (typeof json === "string") {
          try {
            const tempJson = JSON.parse(
              json
                .replaceAll("\\u2060", " ")
                .replaceAll("\\n", "¿quebraLinhaN¿")
                .replaceAll("\\r", "¿quebraLinhaN¿")
                .replaceAll("\\", "")
                .replaceAll("¿quebraLinhaN¿", "\\n")
                .replaceAll('""', '"')
                .replaceAll('"{', "{")
                .replaceAll('}"', "}")
            );
            if (!!tempJson) {
              json = tempJson;
            }
          } catch (error) {}
        }

        if (json.FILEPATH) {
          const response = await handleFiles(json.FILEPATH);
          const hasResponse = !!response;
          if (hasResponse) {
            const fileObject = {
              name: response.name,
              size: response.size,
              type: response.typeMime,
              path_arquivos: json.FILEPATH,
              extension: response.type,
              id: history.id,
            };
            history.file = fileObject;

            history.messagem = json.URL;
          }
          if (!!json && !!json.URL && typeof json.URL === "string") {
            history.messagem = json.URL;
          }
        }

        if (json.HSM_BUTTONS) {
          history.messagem = json.URL;
          if (!!json && !!json.URL && typeof json.URL === "string") {
            history.messagem = json.URL.replace(/\r\n/g, "</br>")
              .replace(/\n/g, "</br>")
              .replace(/\r/g, "</br>");
          }

          let buttonsFormated = [];
          if (json.HSM_BUTTONS.buttons) {
            const buttons = json.HSM_BUTTONS.buttons;
            for (const btn of buttons) {
              const objBtn = {
                payload: btn.index,
                text: btn.parameters[0].text,
              };

              buttonsFormated.push(objBtn);
            }
          } else {
            const buttons = json.HSM_BUTTONS;
            const isButtonsArray = Array.isArray(buttons);
            if (isButtonsArray) {
              for (const btn of buttons) {
                const objBtn = {
                  payload: btn.payload.index,
                  text: btn.payload.value,
                };

                buttonsFormated.push(objBtn);
              }
            } else if (typeof buttons === "object" && "payload" in buttons) {
              const btn = buttons;
              const objBtn = {
                payload: btn.payload.index,
                text: btn.payload.value,
              };

              buttonsFormated.push(objBtn);
            }
          }

          history.buttons = buttonsFormated;
        }
      } else if (history.typename === "contact") {
        const cleanedJsonString = history.messagem.replace(
          /\\(?!["\\/bfnrtu])/g,
          ""
        );
        let json = JSON.parse(cleanedJsonString);

        history.contactInfo = json;
      }

      const reply = historys.find(
        (h) => h.replyid === history.id || h.replyid === history.messageid
      );
      if (reply) {
        history.buttonResponse = reply.messagem;
      }

      if (history.replyid) {
        const findAudit = historys.find(
          (audit) =>
            audit.messageid === history.replyid || audit.id === history.replyid
        );
        if (findAudit) {
          // if (
          //   findAudit.typename === "Interactive" ||
          //   findAudit.typename === "hsm"
          // ) {
          //   findAudit.buttonResponse = history.messagem;
          // }

          let id = findAudit.id ? findAudit.id : findAudit.messageid;

          history.commentResponse = {
            id: id,
            username: findAudit.agente
              ? findAudit.username
              : createJSON(clientTest),
            mensagem:
              findAudit.typename === "contact" ? "Contato" : findAudit.messagem,
            mimetype: findAudit.mimetypeid,
            typename: findAudit.typename,
          };
        }
      }

      processed.push(history);
    }

    // setHistorys(History);
    setHistorys(processed);
    setLoadingHis(false);
  }

  //########### antiga função refactorHistory ##############

  // async function refactorHistory(historys) {
  //   for (const history of historys) {
  //     if (
  //       mimetypesPrincipal.includes(history.typename) &&
  //       !history.messagem.includes("https")
  //     ) {
  //       const response = await handleFiles(history.messagem);

  //       if (response) {
  //         try {
  //           const fileObject = {
  //             name: response.name,
  //             size: response.size,
  //             type: response.typeMime,
  //             path_arquivos: history.messagem,
  //             extension: response.type,
  //             id: history.id,
  //           };
  //           history.file = fileObject;
  //         } catch (error) {
  //           return true;
  //         }
  //       }

  //       //Busca as informações do mimetype caso venha o link completo do arquivo
  //     } else if (
  //       mimetypesPrincipal.includes(history.typename) &&
  //       history.messagem.includes("https")
  //     ) {
  //       const mimetype = Mimetypes.find(
  //         (element) => history.mimetypeid === element.id
  //       );
  //       history.mimetype = mimetype;

  //       //Caso a mensagem seja um json, ele faz o parse para ler o json
  //     } else if (history.typename === "application") {
  //       // history.messagem = JSON.parse(history.messagem).msg || JSON.parse(history.messagem).MSG;
  //       try {
  //         if (
  //           JSON.parse(history.messagem).msg ||
  //           JSON.parse(history.messagem).MSG
  //         ) {
  //           history.messagem =
  //             JSON.parse(history.messagem).msg ||
  //             JSON.parse(history.messagem).MSG;
  //         }

  //         history.messagem = createJSON(history.messagem);
  //       } catch (err) {
  //         console.log("Error: ", err.message);
  //       }

  //       //Caso seja auditória de voz, formata o link que vem do back (vem sem formatação) para poder chamar a função que busca as informações do arquivo.
  //     } else if (history.typename === "Interactive") {
  //       if (history.mimetypeid >= 33 && history.mimetypeid <= 36) {
  //         let json = JSON.parse(history.messagem);
  //         history.buttons = json.buttons;
  //         history.botid = json.botid;

  //         if (json.link) {
  //           const response = await handleFiles(json.link);
  //           try {
  //             const fileObject = {
  //               name: response.name,
  //               size: response.size,
  //               type: response.typeMime,
  //               path_arquivos: json.link,
  //               extension: response.type,
  //               id: history.id,
  //             };
  //             history.file = fileObject;
  //           } catch (error) {
  //             return true;
  //           }
  //         }
  //       } else if (history.mimetypeid === 37) {
  //         let message = history.messagem.replaceAll("\r\n", "\\n");
  //         let json = JSON.parse(message);
  //         history.buttons = json.items;
  //         history.botid = json.botid;
  //       }
  //     } else if (history.typename === "location") {
  //       let json = JSON.parse(history.messagem);
  //       history.location = {
  //         latitude: json.latitude ? json.latitude : json.LATITUDE,
  //         longitude: json.longitude ? json.longitude : json.LONGITUDE,
  //         nomeEndereco: json.name ? json.name : json.NAME,
  //         endereco: json.address ? json.address : json.ADDRESS,
  //       };
  //     } else if (history.typename === "hsm") {
  //       const verifyJson = isJson(history.messagem);
  //       // let json = "";

  //       if (!verifyJson) {
  //         history.messagem = JSON.stringify(
  //           history.messagem.replace(/'/g, '"')
  //         );
  //         // .replace(/\'/g, '"');
  //       }

  //       let json = JSON.parse(history.messagem);
  //       if (json.FILEPATH) {
  //         const response = await handleFiles(json.FILEPATH);
  //         const fileObject = {
  //           name: response.name,
  //           size: response.size,
  //           type: response.typeMime,
  //           path_arquivos: json.FILEPATH,
  //           extension: response.type,
  //           id: history.id,
  //         };
  //         history.file = fileObject;

  //         history.messagem = json.URL;
  //       }

  //       if (json.HSM_BUTTONS) {
  //         history.messagem = json.URL;
  //         let buttonsFormated = [];
  //         if (json.HSM_BUTTONS.buttons) {
  //           const buttons = json.HSM_BUTTONS.buttons;
  //           for (const btn of buttons) {
  //             const objBtn = {
  //               payload: btn.index,
  //               text: btn.parameters[0].text,
  //             };

  //             buttonsFormated.push(objBtn);
  //           }
  //         } else {
  //           const buttons = json.HSM_BUTTONS;
  //           for (const btn of buttons) {
  //             const objBtn = {
  //               payload: btn.payload.index,
  //               text: btn.payload.value,
  //             };

  //             buttonsFormated.push(objBtn);
  //           }
  //         }

  //         history.buttons = buttonsFormated;
  //       }
  //     } else if (history.typename === "contact") {
  //       const cleanedJsonString = history.messagem.replace(
  //         /\\(?!["\\/bfnrtu])/g,
  //         ""
  //       );
  //       let json = JSON.parse(cleanedJsonString);

  //       history.contactInfo = json;
  //     } else if (history.replyid) {
  //       const findAudit = historys.find(
  //         (audit) =>
  //           audit.messageid === history.replyid || audit.id === history.replyid
  //       );
  //       if (findAudit) {
  //         if (
  //           findAudit.typename === "Interactive" ||
  //           findAudit.typename === "hsm"
  //         ) {
  //           findAudit.buttonResponse = history.messagem;
  //         }

  //         let id = findAudit.id ? findAudit.id : findAudit.messageid;

  //         history.commentResponse = {
  //           id: id,
  //           username: findAudit.agente
  //             ? findAudit.username
  //             : createJSON(clientTest),
  //           mensagem:
  //             findAudit.typename === "contact" ? "Contato" : findAudit.messagem,
  //           mimetype: findAudit.mimetypeid,
  //           typename: findAudit.typename,
  //         };
  //       }
  //     }
  //   }

  //   setHistorys(History);
  //   setLoadingHis(false);
  // }

  function createJSON(item) {
    if (item) {
      var mensagem_tratada = item.replace(/¿/gi, "\n");
      mensagem_tratada = mensagem_tratada.replace(/§/gi, "\r\n");
      let valor = 1;
      try {
        mensagem_tratada =
          '{"' +
          valor +
          '": [{"mensagem_tratada":"' +
          mensagem_tratada +
          '"}]}';
        var obj = JSON.parse(mensagem_tratada);
        mensagem_tratada = obj[1][0].mensagem_tratada;
      } catch (e) {
        mensagem_tratada = item;
      }
      return mensagem_tratada;
    }
  }

  const handleAddContact = (contact, typeModal) => {
    axios
      .get(
        `${connection_platform.type_connect}://${pathname}:${port}/conn/getcontacts?number=${contact.telefone}&nome=&empresa=&contato=&codext=&email=`
      )
      .then((response) => {
        if (response.data.length > 0) {
          if (typeModal === "link") {
            MicroModal.show("modal__linkAdd-contact-historic");
            dispatch(GetDetailsContacts(false, response.data[0]));
          } else {
            dispatch(GetDetailsContacts(true, response.data[0], ""));
          }
        } else {
          if (typeModal === "link") {
            MicroModal.show("modal__linkAdd-contact-historic");
            dispatch(GetDetailsContacts(false, contact));
          } else {
            dispatch(GetDetailsContacts(true, "", contact.telefone));

            dispatch(AddNumberContact("", contact.telefone));
            dispatch(GetPhoneMidia([]));
          }
        }
      });
  };

  function tratarBOT(text) {
    let json = JSON.parse(text.replaceAll("\r\n", "\\n"));
    let options = json.options;
    if (parseInt(json.MIMETYPE) === 30) {
      return json.MSG;
    } else if (parseInt(json.mimetype) >= 33 && parseInt(json.mimetype) <= 37) {
      if (json.header) {
        return `*${json.header}*\\r\\n${json.msg}`;
      } else {
        return json.msg;
      }
    } else if (json.address) {
      return json.address;
    } else if (json.HSM_BUTTONS) {
      return json.URL;
    }

    return text;
  }

  const commentFilter = (comment) => {
    if (termText) {
      const mensagemTratada = isJson(comment.messagem)
        ? tratarBOT(comment.messagem)
        : comment.messagem;

      const commentFilter = mensagemTratada
        .toLowerCase()
        .includes(termText.toLowerCase());

      if (commentFilter) {
        return comment;
      } else {
        return;
      }
    } else {
      return comment;
    }
  };

  function renderIconsHistoric(interaction) {
    if (interaction.idmidia === 1) {
      let url = interaction.filerecord;
      let name = "Sem arquivo";
      let namefile;
      if (url) {
        url = url.replace("192.168.178.2", "\\" + interaction.change_path);
        namefile = url.split("\\").pop().split("#")[0].split("?")[0];
      }

      if (interaction.filerecord && InfoUsers.permdownload) {
        return (
          <Play
            className={`icon-actions ${
              interaction.filerecord && InfoUsers.permdownload
                ? ""
                : "message-audio-null"
            }`}
            onClick={(event) =>
              interaction.filerecord && InfoUsers.permdownload
                ? showPlayerAudio(event, interaction.idcdr, interaction)
                : null
            }
          />
        );
      } else {
        return (
          <PlayDisabled
            className={`icon-actions ${
              interaction.filerecord && InfoUsers.permdownload
                ? ""
                : "message-audio-null"
            }`}
            onClick={(event) =>
              interaction.filerecord && InfoUsers.permdownload
                ? showPlayerAudio(event, interaction.idcdr, interaction)
                : null
            }
          />
        );
      }
    } else {
      return (
        <IconSeeInteraction
          className={`icon-actions ${
            interaction.mensagem ? "" : "message-null"
          }`}
          onClick={(event) =>
            interaction.mensagem
              ? showAllHistory(event, interaction.idcdr, interaction)
              : null
          }
        />
      );
    }
  }

  function showPlayerAudio(e, idcdr, data) {
    setDataTitle({
      operator: data.username,
      client: treatmentData.nome_cliente,
      note: data.resultado,
      date: data.datarec,
      midiaid: data.idmidia,
      interaction: data,
    });
    dispatch(GetHistory([]));
    setIsDialogVisible(false);
  }

  function showAllHistory(e, idcdr, data) {
    clientTest = treatmentData.nome_cliente;
    setDataTitle({
      operator: data.username,
      client: treatmentData.nome_cliente,
      note: data.resultado,
      date: data.datarec,
      midiaid: data.idmidia,
      interaction: data,
    });
    let idgroup = InfoUsers.idgroup;
    dispatch(GetHistory([]));
    dispatch(CarregamentoInteractions(idcdr, idgroup));
    setIsDialogVisible(false);
  }

  function defaultSorting(rowA, rowB, columnId) {
    const objectRowA = rowA.original[columnId].data;
    const objectRowB = rowB.original[columnId].data;

    if (objectRowA > objectRowB) return -1;
    if (objectRowB > objectRowA) return 1;
    return 0;
  }

  function customSorting(rowA, rowB, columnId) {
    const customRowA = rowA.original[columnId].config.customOrder;
    const customRowB = rowB.original[columnId].config.customOrder;

    if (customRowA > customRowB) return -1;
    if (customRowB > customRowA) return 1;
    return 0;
  }

  function renderAvaliationTitle(resultado) {
    switch (resultado) {
      case "otimo":
        return (
          <Tooltippy content={resultado} placement="top-start">
            <div className="username-rating__tag happy">
              <HappyRating />
              <div className="client_happy">Cliente satisfeito</div>
            </div>
          </Tooltippy>
        );

      case "promotor":
        return (
          <Tooltippy content={resultado} placement="top-start">
            <div className="username-rating__tag happy">
              <HappyRating />
              <div className="client_happy">Cliente satisfeito</div>
            </div>
          </Tooltippy>
        );

      case "razoavel":
        return (
          <Tooltippy content={resultado} placement="top-start">
            <div className="username-rating__tag indifferent">
              <IndifRating />
              <div className="client_indifferent">Cliente indiferente</div>
            </div>
          </Tooltippy>
        );

      case "neutro":
        return (
          <Tooltippy content={resultado} placement="top-start">
            <div className="username-rating__tag indifferent">
              <IndifRating />
              <div className="client_indifferent">Cliente indiferente</div>
            </div>
          </Tooltippy>
        );

      case "ruim":
        return (
          <Tooltippy content={resultado} placement="top-start">
            <div className="username-rating__tag sad">
              <SadRating />
              <div className="client_sad">Cliente insatisfeito</div>
            </div>
          </Tooltippy>
        );

      case "detrator":
        return (
          <Tooltippy content={resultado} placement="top-start">
            <div className="username-rating__tag sad">
              <SadRating />
              <div className="client_sad">Cliente insatisfeito</div>
            </div>
          </Tooltippy>
        );

      default:
        return (
          <div className="username-rating__tag">
            <NullRating />
            <div className="client_nulo">Nenhuma avaliação</div>
          </div>
        );
    }
  }

  function renderAvaliation(atd) {
    switch (atd.resultado) {
      case "otimo":
        return (
          <Tooltippy content={atd.nota} placement="top-start">
            <div className="username-rating__tag happy">
              <HappyRating />
            </div>
          </Tooltippy>
        );

      case "promotor":
        return (
          <Tooltippy content={atd.nota} placement="top-start">
            <div className="username-rating__tag happy">
              <HappyRating />
            </div>
          </Tooltippy>
        );

      case "razoavel":
        return (
          <Tooltippy content={atd.nota} placement="top-start">
            <div className="username-rating__tag indifferent">
              <IndifRating />
            </div>
          </Tooltippy>
        );

      case "neutro":
        return (
          <Tooltippy content={atd.nota} placement="top-start">
            <div className="username-rating__tag indifferent">
              <IndifRating />
            </div>
          </Tooltippy>
        );

      case "ruim":
        return (
          <Tooltippy content={atd.nota} placement="top-start">
            <div className="username-rating__tag sad">
              <SadRating />
            </div>
          </Tooltippy>
        );

      case "detrator":
        return (
          <Tooltippy content={atd.nota} placement="top-start">
            <div className="username-rating__tag sad">
              <SadRating />
            </div>
          </Tooltippy>
        );

      default:
        return (
          <div className="username-rating__tag">
            <NullRating />
          </div>
        );
    }
  }

  function isJson(item) {
    item = typeof item != "string" ? JSON.stringify(item) : item;

    try {
      item = JSON.parse(item);
    } catch (e) {
      return false;
    }

    if (typeof item === "object" && item != null) {
      return true;
    }

    return false;
  }

  function exhibMessage(interaction) {
    if (interaction.idmidia === 1) {
      let url = interaction.filerecord;
      let name = "Sem arquivo";
      let namefile;
      if (url) {
        url = url.replace("192.168.178.2", "\\" + interaction.change_path);
        namefile = url.split("\\").pop().split("#")[0].split("?")[0];
      }
      const audioLink =
        connection_platform.type_connect + "://" + ipcurrent + url;
      return (
        <div className="message-table">
          <Audio audio link={InfoUsers.permreproduce ? audioLink : ""} />
        </div>
      );
    } else if (
      interaction.mensagem === null ||
      interaction.mensagem === "" ||
      interaction.mensagem === ""
    ) {
      return (
        <div className="message-table">
          <Typography.H6 color={"gray-125"}>
            Sem mensagem de texto
          </Typography.H6>
        </div>
      );
    } else {
      if (isJson(interaction.mensagem) === true) {
        let json = JSON.parse(interaction.mensagem);
        let options = json.options;
        let i = 1;
        var opcoes = [];
        for (i in options) {
          opcoes.push(i + " - " + options[i][1]);
        }
        let mensagem = json.msg + " \r\n ";
        return (
          <div
            className="message-table"
            style={{ pointerEvents: "none" }}
            onClick={(event) => blockClick(event)}
          >
            <Typography.H6 color={"gray-180"}>
              {ReactHtmlParser(`<p>${mensagem}</p>`)}
            </Typography.H6>
          </div>
        );
      } else {
        var mensagem_tratada = interaction.mensagem;
        let valor = 1;
        try {
          mensagem_tratada =
            '{"' +
            valor +
            '": [{"mensagem_tratada":"' +
            mensagem_tratada +
            '"}]}';
          var obj = JSON.parse(mensagem_tratada);
          mensagem_tratada = obj[1][0].mensagem_tratada;
        } catch (e) {
          mensagem_tratada = interaction.mensagem;
        }
        if (interaction.idmidia === 3) {
          return (
            <div className="message-table__email">
              <Typography.H6 color={"gray-180"}>
                {ReactHtmlParser(`<p>${mensagem_tratada}</p>`)}
              </Typography.H6>
            </div>
          );
        } else {
          return (
            <div
              className="message-table"
              style={{ pointerEvents: "none" }}
              onClick={(event) => blockClick(event)}
            >
              <Typography.H6 color={"gray-180"}>
                {ReactHtmlParser(`<p>${mensagem_tratada}</p>`)}
              </Typography.H6>
            </div>
          );
        }
      }
    }
  }

  function channelIcon(idmidia) {
    if (idmidia === 1) {
      return (
        <div className="icon-container">
          <img
            alt="Logo Chamada de Voz"
            src={CALLCHAT2}
            className="icon-container__icon"
          />
        </div>
      );
    } else if (idmidia === 2) {
      return (
        <div className="icon-container">
          <img
            alt="Logo Web"
            src={MIDIAWEB2}
            className="icon-container__icon"
          />
        </div>
      );
    } else if (idmidia === 6) {
      return (
        <div className="icon-container">
          <img
            alt="Logo do Instagram"
            src={INSTAGRAM2}
            className="icon-container__icon"
          />
        </div>
      );
    } else if (idmidia === 5) {
      return (
        <div className="icon-container">
          <img
            alt="Logo do Whatsapp"
            src={MIDIAZAP2}
            className="icon-container__icon"
          />
        </div>
      );
    } else if (idmidia === 3) {
      return (
        <div className="icon-container">
          <img
            alt="Logo do Email"
            src={MIDIAEMAIL2}
            className="icon-container__icon"
          />
        </div>
      );
    } else if (idmidia === 4) {
      return (
        <div className="icon-container">
          <img
            alt="Logo do Facebook"
            src={MIDIAFACE2}
            className="icon-container__icon"
          />
        </div>
      );
    } else if (idmidia === 8) {
      return (
        <div className="icon-container">
          <img
            alt="Logo do Telegram"
            src={MIDIATELEGRAM2}
            className="icon-container__icon"
          />
        </div>
      );
    } else if (idmidia === 9) {
      return (
        <div className="icon-container">
          <img
            alt="Logo do Twitter"
            src={TWITTER2}
            className="icon-container__icon"
          />
        </div>
      );
    } else if (idmidia === 10) {
      return (
        <div className="icon-container">
          <img
            alt="Logo do LinkedIn"
            src={LINKEDIN2}
            className="icon-container__icon"
          />
        </div>
      );
    } else if (idmidia === 11) {
      return (
        <div className="icon-container">
          <img
            alt="Logo do LinkedIn"
            src={GOOGLEGBM2}
            className="icon-container__icon"
          />
        </div>
      );
    } else if (idmidia === 12) {
      return (
        <div className="icon-container">
          <div className="icon-container__svg">
            <SMSICON />
          </div>
        </div>
      );
    } else if (idmidia === 15) {
      return (
        <div className="icon-container">
          <img
            alt="Logo do Teams"
            src={TEAMS2}
            className="icon-container__icon"
          />
        </div>
      );
    }
  }

  function renderAudioPlayer(interaction) {
    if (interaction) {
      let url = interaction.filerecord;
      let name = "Sem arquivo";
      let namefile;
      if (url) {
        url = url.replace("192.168.178.2", "\\" + interaction.change_path);
        namefile = url.split("\\").pop().split("#")[0].split("?")[0];
      }
      const audioLink =
        connection_platform.type_connect + "://" + ipcurrent + url;
      return (
        <div className="audio-player__interaction">
          <Audio audio link={audioLink} />
        </div>
      );
    }
  }

  function channelIconTitle(idmidia) {
    if (idmidia === 1) {
      return (
        <div className="icon-container">
          <CALLCHAT />
        </div>
      );
    } else if (idmidia === 2) {
      return (
        <div className="icon-container">
          <MIDIAWEB />
        </div>
      );
    } else if (idmidia === 6) {
      return (
        <div className="icon-container">
          <INSTAGRAM />
        </div>
      );
    } else if (idmidia === 5) {
      return (
        <div className="icon-container">
          <MIDIAZAP />
        </div>
      );
    } else if (idmidia === 3) {
      return (
        <div className="icon-container">
          <MIDIAEMAIL />
        </div>
      );
    } else if (idmidia === 4) {
      return (
        <div className="icon-container">
          <MIDIAFACE />
        </div>
      );
    } else if (idmidia === 8) {
      return (
        <div className="icon-container">
          <MIDIATELEGRAM />
        </div>
      );
    } else if (idmidia === 9) {
      return (
        <div className="icon-container">
          <TWITTER />
        </div>
      );
    } else if (idmidia === 10) {
      return (
        <div className="icon-container">
          <LINKEDIN />
        </div>
      );
    } else if (idmidia === 11) {
      return (
        <div className="icon-container">
          <GOOGLEGBM />
        </div>
      );
    } else if (idmidia === 15) {
      return (
        <div className="icon-container">
          <TEAMS />
        </div>
      );
    }
  }

  function getBackgroundColor(npsNote) {
    if (npsNote >= 0 && npsNote <= 6) {
      return "#c90000";
    } else if (npsNote === 7 || npsNote === 8) {
      return "#F2BD00";
    } else if (npsNote === 9 || npsNote === 10) {
      return "#008908";
    } else {
      return "#c90000";
    }
  }

  function formatPhoneNumber(phoneNumber) {
    if (!phoneNumber) return "";

    const ddd = phoneNumber.substring(0, 2);
    const number = phoneNumber.substring(2);

    return `(${ddd}) ${number}`;
  }

  function refactorInteractionsData(data) {
    let dataRefactored = [];

    data.forEach((datum) => {
      const formatDate = datum.datarec.split(" ");
      const dateGet = formatDate[0];
      const hourGet = formatDate[1];

      const splitDate = dateGet.split("/");
      const reverseDate = splitDate.reverse();
      const dateOrder = `${reverseDate.join("/")} ${hourGet}`;

      const fileShareRefactored = {
        channel: {
          data: channelIcon(datum.idmidia),
          config: {
            textEllipsis: true,
            customOrder: datum.idmidia,
          },
        },
        operator: {
          data: (
            <Typography.H6 color={"gray-180"}>{datum.username}</Typography.H6>
          ),
          config: {
            textEllipsis: true,
          },
        },
        date: {
          data: (
            <Typography.H6 color={"gray-180"}>{datum.datarec}</Typography.H6>
          ),
          config: {
            textEllipsis: true,
            customOrder: new Date(dateOrder),
          },
        },
        avaliation: {
          data: renderAvaliation(datum),
          config: {
            textEllipsis: true,
            customOrder: datum.nota,
          },
        },
        action: {
          data: renderIconsHistoric(datum),
          config: {
            textEllipsis: true,
          },
        },
      };

      dataRefactored.push(fileShareRefactored);
    });

    return dataRefactored;
  }

  const interactionsData = useMemo(() => {
    if (dialogsInteractions.length !== 0) {
      const dataRefactored = refactorInteractionsData(dialogsInteractions);

      setLoading(false);
      return dataRefactored;
    }
  }, [dialogsInteractions]);

  const columns = [
    {
      Header: "Canal",
      accessor: "channel",
      id: "channel",
      sortType: customSorting,
      disableFilters: true,
      display: true,
    },
    {
      Header: "Operador",
      accessor: "operator",
      id: "operator",
      sortType: defaultSorting,
      disableFilters: true,
      display: true,
    },
    {
      Header: "Data",
      accessor: "date",
      id: "date",
      sortType: customSorting,
      disableFilters: true,
      display: true,
    },
    {
      Header: "Satisfação",
      accessor: "avaliation",
      id: "avaliation",
      sortType: customSorting,
      disableFilters: true,
      display: true,
    },
    {
      Header: "Auditoria",
      accessor: "action",
      id: "action",
      disableSortBy: true,
      disableFilters: true,
      display: true,
    },
  ];

  useEffect(() => {
    dispatch(InteracoesDealGet(treatmentData.id_cdr));
  }, []);

  return (
    <div
      className={`user-history-container ${userHistoryDrawer ? "" : "closed"}`}
    >
      <header className="user-history-container__header">
        <div>
          <ArrowBackIcon onClick={returnScreenDrawer} />

          <Typography.H1 color="blue-selected-4" weight={700}>
            Ver Interações
          </Typography.H1>
        </div>

        <button
          className="user-history-container__header__close"
          onClick={returnScreenDrawer}
        >
          <CloseIcon />
        </button>
      </header>

      <main className="user-history-container__content">
        {isDialogVisible ? (
          <div className="modal__content__user-details__content">
            <div className="modal__content__tabs__body__tab__result interaction-modal">
              {loading ? (
                <Loading.Paperplane fullPage={true} />
              ) : dialogsInteractions.length > 0 &&
                interactionsData.length > 0 ? (
                <Table
                  className="table-fileShare"
                  data={interactionsData}
                  columns={columns}
                  fixedHeader
                  // fixedFirstColumn
                  // filtersActive={filtersActive}
                  // emptyState={emptyState}
                  // setEmptyState={setEmptyState}
                  // initialState={sortBy}
                  // screen="manager"
                />
              ) : (
                <div className="modal__empty-state">
                  <div className="modal__nully-icon">
                    <IconMessageNull />
                  </div>
                  <div className="modal__nully-text">
                    <Typography.H4 color={"black"}>
                      Não há interações nesse período.
                    </Typography.H4>
                  </div>
                </div>
              )}
            </div>
          </div>
        ) : (
          <div className="user-interaction__dialog">
            <div className="user-interaction__dialog-header">
              <div className="user-interaction__dialog-header__container">
                <div className="user-interaction__dialog-header__container-profile">
                  <div className="user-interaction__dialog-header__container-icon">
                    {channelIconTitle(dataTitle.midiaid)}
                  </div>
                  <UserProfileIcon />
                </div>
                <div className="user-interaction__dialog-header__evaluation">
                  <div className="user-interaction__dialog-header__title">
                    {dataTitle.client} <ArrowsIcon /> {dataTitle.operator}
                  </div>
                  <div className="user-interaction__dialog-header__line">
                    <div className="user-interaction__dialog-header__satisfaction">
                      {renderAvaliationTitle(dataTitle.note)}
                    </div>
                    <div className="user-interaction__dialog-header__date">
                      {dataTitle.date}
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <SearchIcon />
              </div>
            </div>
            {dataTitle.midiaid !== 1 ? (
              <div className="user-interaction__dialog-body">
                {historys.filter(commentFilter).map((history, index) => {
                  let dataHoraEnvio = "";
                  if (history.data_hora_envio) {
                    const getData = history.data_hora_envio.split(" ");
                    const organizeData = getData[0]
                      .split("/")
                      .reverse()
                      .join("/");
                    dia = organizeData;
                  } else if (history.dataenvio) {
                    dia = history.dataenvio.split("/").reverse().join("/");
                  }

                  if (dia != auxdia) {
                    dia = dia;
                    auxdia = dia;
                  } else {
                    auxdia = dia;
                    dia = "";
                  }

                  let mensagem_tratada = "";
                  if (history.caption) {
                    mensagem_tratada = history.caption;
                  } else if (history.contactInfo) {
                    mensagem_tratada = " ";
                  } else {
                    mensagem_tratada = history.messagem.replaceAll(
                      "\r\n",
                      "\\n"
                    );
                  }

                  return (
                    <InteractionComment
                      key={index}
                      id={history.messageid ? history.messageid : history.id}
                      inputSearch={termText}
                      text={mensagem_tratada}
                      type={
                        mimetypesPrincipal.includes(history.typename)
                          ? "attachment"
                          : ""
                      }
                      date={{
                        horaEnvio: history.data_hora_envio
                          ? history.data_hora_envio.split(" ")[1]
                          : new Date(history.datesend).toLocaleTimeString([], {
                              hour: "2-digit",
                              minute: "2-digit",
                            }),
                        horaLida: history.dateread,
                        horaError: history.dateerror,
                        dia: dia ? new Date(dia) : "",
                      }}
                      attachment={history.file}
                      size={history.filesize}
                      mimetypeId={history.mimetypeid}
                      mimetype={history.mimetype}
                      typeName={history.typename}
                      name={
                        history.agente
                          ? history.username
                          : createJSON(ContactId.cliente)
                      }
                      direction={
                        history.agente && history.mon_type_id === 0
                          ? "right"
                          : "left"
                      }
                      buttons={history.buttons}
                      botId={history.botid}
                      reply={history.commentResponse}
                      buttonResponse={history.buttonResponse}
                      location={history.location}
                      allInfo={history}
                      titleOptions={false}
                      contactInfo={history.contactInfo}
                      contactLinkAdd={handleAddContact}
                      actionCallInfo={() =>
                        MicroModal.close(
                          "modal__historico-atendimento-contact-2"
                        )
                      }
                    />
                  );
                })}
              </div>
            ) : (
              <div className="user-interaction__dialog-body">
                {renderAudioPlayer(dataTitle.interaction)}
              </div>
            )}
          </div>
        )}
      </main>
    </div>
  );
}
